import { createSlice } from '@reduxjs/toolkit';
import {
    fetchOperationalLogs,
    addOperationalLog,
    getOperationalLogById,
    editOperationalLog,
    deleteOperationalLog
} from '../actions/operationalLog';

export const operationalLogSlice = createSlice({
    name: 'operationalLog',
    initialState: {
        loading: false,
        data: [],
        addedLog: null,
        logToEdit: null,
        logToEditLoading: false,
        editedLog: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // FETCH OPERATIONAL LOGS
            .addCase(fetchOperationalLogs.pending, (state) => { state.loading = true })
            .addCase(fetchOperationalLogs.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchOperationalLogs.rejected, (state) => { state.loading = false })
            // ADD OPERATIONAL LOG
            .addCase(addOperationalLog.pending, (state) => { state.loading = true })
            .addCase(addOperationalLog.fulfilled, (state, action) => {
                state.loading = false;
                state.addedLog = action.payload;
            })
            .addCase(addOperationalLog.rejected, (state) => { state.loading = false })
            // GET OPERATIONAL LOG BY ID
            .addCase(getOperationalLogById.pending, (state) => { state.logToEditLoading = true })
            .addCase(getOperationalLogById.fulfilled, (state, action) => {
                state.logToEditLoading = false;
                state.logToEdit = action.payload;
            })
            .addCase(getOperationalLogById.rejected, (state) => { state.logToEditLoading = false })
            // EDIT OPERATIONAL LOG
            .addCase(editOperationalLog.pending, (state) => { state.logToEditLoading = true })
            .addCase(editOperationalLog.fulfilled, (state, action) => {
                state.logToEditLoading = false;
                state.editedLog = action.payload;
            })
            .addCase(editOperationalLog.rejected, (state) => { state.logToEditLoading = false })
            // DELETE OPERATIONAL LOG
            .addCase(deleteOperationalLog.pending, (state) => { state.loading = true })
            .addCase(deleteOperationalLog.fulfilled, (state) => { state.loading = false })
            .addCase(deleteOperationalLog.rejected, (state) => { state.loading = false });
    }
});

export default operationalLogSlice.reducer;
